function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, Object, String, hasBodyScrolled, sortField, sortOrder) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['field-with-matches'] = function(item, context) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((context.matchParts) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = (context.matchParts);
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, part, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "class": {
                        'mp-table-cell-match-part': true
                      },
                    }, [__vjadeSafeCode(part)]));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var part = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("span", {
                          "class": {
                            'mp-table-cell-match-part': true
                          },
                        }, [__vjadeSafeCode(part)]));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(context.label);;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['cell-type-text'] = function(item, context) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(jade_mixins['field-with-matches'].call(this, item, context));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['cell-type-user'] = function(item, context) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-user-icon", {
          "attrs": {
            name: context.label,
            'show-tooltip': false
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-table-cell-type-user-label': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['field-with-matches'].call(this, item, context));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['cell-type-checkbox'] = function(item, context) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const options = $helpers.getCheckboxState(item);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "on": {
            click: ev => !options.attrs.disabled && $helpers.toggleSelected(ev, item, context.rowIdx)
          },
          "attrs": {
            title: $helpers.rangeSelectAllowed() ? `shift + click for range select` : ``
          },
          "class": Object.assign({}, {
            disabled: options.attrs.disabled,
            'will-range-select': $helpers.willRangeSelect(context.rowIdx)
          }, {
            'mp-table-checkbox-wrapper': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-checkbox", {
            "attrs": options.attrs,
          }));
          __jade_nodes = __jade_nodes.concat((options.selectDisabledReason && options.attrs.disabled) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
              "attrs": {
                placement: `right`
              },
            }, [__vjadeSafeCode(options.selectDisabledReason)]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['column-title'] = function(column, context) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((column.titleRenderer) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(column.titleRenderer(column, context));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'text': true
            },
          }, [__vjadeSafeCode(context.title)]));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const rowsToDisplay = $helpers.getRowsToDisplay();
    const colsToDisplay = $helpers.getColumnsToDisplay($mixins);;
    const isGroupingEnabled = $helpers.isGroupingEnabled();
    return {
      value: (h("div", {
        "class": {
          'mp-table': true
        },
      }, (function() {
        var __jade_nodes = [];
        const isSticky = $attr(`sticky-titles`);;
        const stickyTitlesOffset = $attr(`sticky-titles-offset`);;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "style": (isSticky ? {
            top: `${stickyTitlesOffset}px`
          } : {}),
          "class": Object.assign({}, {
            'mp-table-titles-sticky': isSticky
          }, {
            'mp-table-titles': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (colsToDisplay);
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, column, colIndex) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  const isCurrSortField = sortField === column.field;
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "style": {
                      flexGrow: column.flexGrow || `0`,
                      flexBasis: column.flexBasis,
                    },
                    "on": {
                      click: () => $helpers.handleHeaderTitleClick(column),
                    },
                    "class": Object.assign({}, {
                      'mp-table-can-sort': column.isSortable,
                      'mp-table-sort-column': isCurrSortField,
                      [`mp-table-title-cell-type-${column.type}`]: !!column.type,
                      [`title-cell-field-${column.field}`]: true,
                    }, {
                      'mp-table-title-cell': true
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((column.type === `checkbox`) ? ((function() {
                      var __jade_nodes = []; /*  checkbox-wrapper so we can increase click surface area */
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "style": {
                          pointerEvents: $attr(`multi-select`) ? `` : `none`
                        },
                        "on": {
                          click: $helpers.toggleAllSelected
                        },
                        "class": {
                          'mp-table-checkbox-wrapper': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(($attr(`multi-select`)) ? ((function() {
                          var __jade_nodes = [];
                          const {
                            numSelected,
                            allSelected
                          } = $helpers.getSelectionStats();
                          __jade_nodes = __jade_nodes.concat(h("mp-checkbox", {
                            "attrs": {
                              checked: allSelected,
                              'unchecked-icon': numSelected > 0 ? `dash` : ``,
                            },
                          }));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);
                    __jade_nodes = __jade_nodes.concat((column.title) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-table-title-label': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        const maxLength = column.titleMaxLength || $helpers.COLUMN_TITLE_MAX_LENGTH;
                        const columnTitle = column.title.length > maxLength ? $helpers.truncateMiddle(column.title, maxLength) : column.title;
                        __jade_nodes = __jade_nodes.concat((column.title.length > maxLength) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['column-title'].call(this, column, {
                            colIndex,
                            title: columnTitle
                          }));
                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                            "attrs": {
                              'max-width': '250px',
                              'placement': $helpers.getTitleTooltipPlacement(colIndex, colsToDisplay.length),
                            },
                          }, [__vjadeSafeCode(column.title)]));;
                          return __jade_nodes
                        }).call(this)) : ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['column-title'].call(this, column, {
                            colIndex,
                            title: columnTitle
                          }));;
                          return __jade_nodes
                        }).call(this)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);
                    __jade_nodes = __jade_nodes.concat((column.helpText) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-table-title-help-text': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        const hrefVal = column.helpLink ? column.helpLink : `javascript:void(0)`;;
                        __jade_nodes = __jade_nodes.concat(h("a", {
                          "attrs": {
                            href: hrefVal,
                            target: `_blank`
                          },
                          "class": {
                            'mp-table-title-help-link': !!column.helpLink
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                            "attrs": {
                              icon: `info`
                            },
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": {
                            'max-width': '250px',
                            'placement': column.helpTextPlacement
                          },
                        }, [__vjadeSafeCode(column.helpText)]));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);
                    __jade_nodes = __jade_nodes.concat((column.isSortable) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": Object.assign({}, {
                          [`mp-table-sort-${sortOrder === 1? `asc` : `desc`}`]: isCurrSortField
                        }, {
                          'mp-table-sort-controls': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'mp-table-sort-caret-up': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                            "attrs": {
                              icon: `caret-up`
                            },
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'mp-table-sort-caret-down': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                            "attrs": {
                              icon: `caret-down`
                            },
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var colIndex = $$objKey;
                  if ($$obj.hasOwnProperty(colIndex)) {
                    $$iterated = true;
                    var column = $$obj[colIndex];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      const isCurrSortField = sortField === column.field;
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "style": {
                          flexGrow: column.flexGrow || `0`,
                          flexBasis: column.flexBasis,
                        },
                        "on": {
                          click: () => $helpers.handleHeaderTitleClick(column),
                        },
                        "class": Object.assign({}, {
                          'mp-table-can-sort': column.isSortable,
                          'mp-table-sort-column': isCurrSortField,
                          [`mp-table-title-cell-type-${column.type}`]: !!column.type,
                          [`title-cell-field-${column.field}`]: true,
                        }, {
                          'mp-table-title-cell': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((column.type === `checkbox`) ? ((function() {
                          var __jade_nodes = []; /*  checkbox-wrapper so we can increase click surface area */
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "style": {
                              pointerEvents: $attr(`multi-select`) ? `` : `none`
                            },
                            "on": {
                              click: $helpers.toggleAllSelected
                            },
                            "class": {
                              'mp-table-checkbox-wrapper': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(($attr(`multi-select`)) ? ((function() {
                              var __jade_nodes = [];
                              const {
                                numSelected,
                                allSelected
                              } = $helpers.getSelectionStats();
                              __jade_nodes = __jade_nodes.concat(h("mp-checkbox", {
                                "attrs": {
                                  checked: allSelected,
                                  'unchecked-icon': numSelected > 0 ? `dash` : ``,
                                },
                              }));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat((column.title) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-table-title-label': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            const maxLength = column.titleMaxLength || $helpers.COLUMN_TITLE_MAX_LENGTH;
                            const columnTitle = column.title.length > maxLength ? $helpers.truncateMiddle(column.title, maxLength) : column.title;
                            __jade_nodes = __jade_nodes.concat((column.title.length > maxLength) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(jade_mixins['column-title'].call(this, column, {
                                colIndex,
                                title: columnTitle
                              }));
                              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                "attrs": {
                                  'max-width': '250px',
                                  'placement': $helpers.getTitleTooltipPlacement(colIndex, colsToDisplay.length),
                                },
                              }, [__vjadeSafeCode(column.title)]));;
                              return __jade_nodes
                            }).call(this)) : ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(jade_mixins['column-title'].call(this, column, {
                                colIndex,
                                title: columnTitle
                              }));;
                              return __jade_nodes
                            }).call(this)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat((column.helpText) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-table-title-help-text': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            const hrefVal = column.helpLink ? column.helpLink : `javascript:void(0)`;;
                            __jade_nodes = __jade_nodes.concat(h("a", {
                              "attrs": {
                                href: hrefVal,
                                target: `_blank`
                              },
                              "class": {
                                'mp-table-title-help-link': !!column.helpLink
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                "attrs": {
                                  icon: `info`
                                },
                              }));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": {
                                'max-width': '250px',
                                'placement': column.helpTextPlacement
                              },
                            }, [__vjadeSafeCode(column.helpText)]));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat((column.isSortable) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": Object.assign({}, {
                              [`mp-table-sort-${sortOrder === 1? `asc` : `desc`}`]: isCurrSortField
                            }, {
                              'mp-table-sort-controls': true
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'mp-table-sort-caret-up': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                "attrs": {
                                  icon: `caret-up`
                                },
                              }));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'mp-table-sort-caret-down': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                "attrs": {
                                  icon: `caret-down`
                                },
                              }));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })());;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "style": {
            maxHeight: $attr(`max-body-height`),
          },
          "on": {
            mouseleave: $helpers.handleBodyMouseLeave,
            mouseenter: $helpers.handleBodyMouseEnter,
            scroll: !$attr(`window-scroll`) && $helpers.handleScroll,
          },
          "hook": {
            insert: ({
              elm
            }) => $helpers.updateElRef({
              tableBody: elm
            }),
          },
          "class": Object.assign({}, {
            'mp-table-body-clickable': $attr(`clickable-rows`),
            'mp-table-body-scroll': !$attr(`window-scroll`),
            'mp-table-body-scrolled': hasBodyScrolled,
          }, {
            'mp-table-body': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`loading`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-table-row': true,
                'mp-table-row-empty': true,
                'mp-table-row-loading': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : (rowsToDisplay.length) ? ((function() {
            var __jade_nodes = [];
            const needsRowMouseEnter = $attr(`row-focused-context`) || $attr(`multi-select`);;
            let prevRowContexts = null;
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = (rowsToDisplay);
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, row, rowIdx) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "on": {
                        click: ev => $helpers.handleRowClick(ev, row.val, rowIdx),
                        mouseenter: needsRowMouseEnter && (() => $helpers.handleRowMouseEnter(rowIdx)),
                      },
                      "class": Object.assign({}, {
                        [`mp-table-row-no-border`]: isGroupingEnabled,
                        [`mp-table-row-selected`]: row.val.isSelected,
                      }, {
                        'mp-table-row': true
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      const currRowContexts = $helpers.getCellRenderContexts(colsToDisplay, row, rowIdx, rowsToDisplay.length);
                      const groupedColIndices = isGroupingEnabled && $helpers.getGroupedColIndices(colsToDisplay, prevRowContexts, currRowContexts);
                      __jade_nodes = __jade_nodes.concat((row.val.isNew) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'mp-table-new-row-indicator': true
                          },
                        }));;
                        return __jade_nodes
                      }).call(this)) : undefined);
                      __jade_nodes = __jade_nodes.concat((function() {
                        var $$obj = (colsToDisplay);
                        var $$eachNodes;
                        var $$iterated = false;
                        if (Array.isArray($$obj)) {
                          $$eachNodes = $$obj.reduce(function($$eachNodes, column, columnIdx) {
                            $$iterated = true;
                            return $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              const columnType = $helpers.getColumnType(row.val, column);
                              const context = currRowContexts[columnIdx];
                              const cellRenderer = column.cellRenderer || $mixins[`cell-type-${columnType}`];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "style": {
                                  flexGrow: column.flexGrow || `0`,
                                  flexBasis: column.flexBasis
                                },
                                "on": {
                                  click: ev => $helpers.handleCellClick(ev, row.val, column.field, context)
                                },
                                "class": Object.assign({}, {
                                  [`cell-field-${column.field}`]: true,
                                  [`mp-table-cell-has-right-border`]: isGroupingEnabled && column.isGroupable,
                                  [`mp-table-cell-has-top-border`]: isGroupingEnabled && rowIdx > 0 && !groupedColIndices.has(columnIdx),
                                  [`mp-table-cell-sortable`]: column.isSortable,
                                  [`mp-table-cell-type-${columnType}`]: !!columnType,
                                }, {
                                  'mp-table-cell': true
                                }),
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat((!(isGroupingEnabled && groupedColIndices.has(columnIdx))) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat((cellRenderer) ? ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(cellRenderer(row.val, context));;
                                    return __jade_nodes
                                  }).call(this)) : ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(jade_mixins['cell-type-text'].call(this, row.val, context));;
                                    return __jade_nodes
                                  }).call(this)));;
                                  return __jade_nodes
                                }).call(this)) : undefined);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }, []);
                        } else {
                          $$eachNodes = [];
                          for (var $$objKey in $$obj) {
                            (function() {
                              var columnIdx = $$objKey;
                              if ($$obj.hasOwnProperty(columnIdx)) {
                                $$iterated = true;
                                var column = $$obj[columnIdx];
                                $$eachNodes = $$eachNodes.concat((function() {
                                  var __jade_nodes = [];
                                  const columnType = $helpers.getColumnType(row.val, column);
                                  const context = currRowContexts[columnIdx];
                                  const cellRenderer = column.cellRenderer || $mixins[`cell-type-${columnType}`];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "style": {
                                      flexGrow: column.flexGrow || `0`,
                                      flexBasis: column.flexBasis
                                    },
                                    "on": {
                                      click: ev => $helpers.handleCellClick(ev, row.val, column.field, context)
                                    },
                                    "class": Object.assign({}, {
                                      [`cell-field-${column.field}`]: true,
                                      [`mp-table-cell-has-right-border`]: isGroupingEnabled && column.isGroupable,
                                      [`mp-table-cell-has-top-border`]: isGroupingEnabled && rowIdx > 0 && !groupedColIndices.has(columnIdx),
                                      [`mp-table-cell-sortable`]: column.isSortable,
                                      [`mp-table-cell-type-${columnType}`]: !!columnType,
                                    }, {
                                      'mp-table-cell': true
                                    }),
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat((!(isGroupingEnabled && groupedColIndices.has(columnIdx))) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat((cellRenderer) ? ((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(cellRenderer(row.val, context));;
                                        return __jade_nodes
                                      }).call(this)) : ((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(jade_mixins['cell-type-text'].call(this, row.val, context));;
                                        return __jade_nodes
                                      }).call(this)));;
                                      return __jade_nodes
                                    }).call(this)) : undefined);;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this));
                              }
                            })();
                          }
                        }

                        return $$eachNodes;
                      })());
                      prevRowContexts = currRowContexts;;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var rowIdx = $$objKey;
                    if ($$obj.hasOwnProperty(rowIdx)) {
                      $$iterated = true;
                      var row = $$obj[rowIdx];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "on": {
                            click: ev => $helpers.handleRowClick(ev, row.val, rowIdx),
                            mouseenter: needsRowMouseEnter && (() => $helpers.handleRowMouseEnter(rowIdx)),
                          },
                          "class": Object.assign({}, {
                            [`mp-table-row-no-border`]: isGroupingEnabled,
                            [`mp-table-row-selected`]: row.val.isSelected,
                          }, {
                            'mp-table-row': true
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          const currRowContexts = $helpers.getCellRenderContexts(colsToDisplay, row, rowIdx, rowsToDisplay.length);
                          const groupedColIndices = isGroupingEnabled && $helpers.getGroupedColIndices(colsToDisplay, prevRowContexts, currRowContexts);
                          __jade_nodes = __jade_nodes.concat((row.val.isNew) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'mp-table-new-row-indicator': true
                              },
                            }));;
                            return __jade_nodes
                          }).call(this)) : undefined);
                          __jade_nodes = __jade_nodes.concat((function() {
                            var $$obj = (colsToDisplay);
                            var $$eachNodes;
                            var $$iterated = false;
                            if (Array.isArray($$obj)) {
                              $$eachNodes = $$obj.reduce(function($$eachNodes, column, columnIdx) {
                                $$iterated = true;
                                return $$eachNodes.concat((function() {
                                  var __jade_nodes = [];
                                  const columnType = $helpers.getColumnType(row.val, column);
                                  const context = currRowContexts[columnIdx];
                                  const cellRenderer = column.cellRenderer || $mixins[`cell-type-${columnType}`];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "style": {
                                      flexGrow: column.flexGrow || `0`,
                                      flexBasis: column.flexBasis
                                    },
                                    "on": {
                                      click: ev => $helpers.handleCellClick(ev, row.val, column.field, context)
                                    },
                                    "class": Object.assign({}, {
                                      [`cell-field-${column.field}`]: true,
                                      [`mp-table-cell-has-right-border`]: isGroupingEnabled && column.isGroupable,
                                      [`mp-table-cell-has-top-border`]: isGroupingEnabled && rowIdx > 0 && !groupedColIndices.has(columnIdx),
                                      [`mp-table-cell-sortable`]: column.isSortable,
                                      [`mp-table-cell-type-${columnType}`]: !!columnType,
                                    }, {
                                      'mp-table-cell': true
                                    }),
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat((!(isGroupingEnabled && groupedColIndices.has(columnIdx))) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat((cellRenderer) ? ((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(cellRenderer(row.val, context));;
                                        return __jade_nodes
                                      }).call(this)) : ((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(jade_mixins['cell-type-text'].call(this, row.val, context));;
                                        return __jade_nodes
                                      }).call(this)));;
                                      return __jade_nodes
                                    }).call(this)) : undefined);;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this));
                              }, []);
                            } else {
                              $$eachNodes = [];
                              for (var $$objKey in $$obj) {
                                (function() {
                                  var columnIdx = $$objKey;
                                  if ($$obj.hasOwnProperty(columnIdx)) {
                                    $$iterated = true;
                                    var column = $$obj[columnIdx];
                                    $$eachNodes = $$eachNodes.concat((function() {
                                      var __jade_nodes = [];
                                      const columnType = $helpers.getColumnType(row.val, column);
                                      const context = currRowContexts[columnIdx];
                                      const cellRenderer = column.cellRenderer || $mixins[`cell-type-${columnType}`];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "style": {
                                          flexGrow: column.flexGrow || `0`,
                                          flexBasis: column.flexBasis
                                        },
                                        "on": {
                                          click: ev => $helpers.handleCellClick(ev, row.val, column.field, context)
                                        },
                                        "class": Object.assign({}, {
                                          [`cell-field-${column.field}`]: true,
                                          [`mp-table-cell-has-right-border`]: isGroupingEnabled && column.isGroupable,
                                          [`mp-table-cell-has-top-border`]: isGroupingEnabled && rowIdx > 0 && !groupedColIndices.has(columnIdx),
                                          [`mp-table-cell-sortable`]: column.isSortable,
                                          [`mp-table-cell-type-${columnType}`]: !!columnType,
                                        }, {
                                          'mp-table-cell': true
                                        }),
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat((!(isGroupingEnabled && groupedColIndices.has(columnIdx))) ? ((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat((cellRenderer) ? ((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(cellRenderer(row.val, context));;
                                            return __jade_nodes
                                          }).call(this)) : ((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(jade_mixins['cell-type-text'].call(this, row.val, context));;
                                            return __jade_nodes
                                          }).call(this)));;
                                          return __jade_nodes
                                        }).call(this)) : undefined);;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this));
                                  }
                                })();
                              }
                            }

                            return $$eachNodes;
                          })());
                          prevRowContexts = currRowContexts;;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-table-row': true,
                'mp-table-row-empty': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($attr(`search-filter`).trim()) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Your search returned no results");;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat($attr(`empty-message`));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "hasBodyScrolled" in locals ? locals.hasBodyScrolled : typeof hasBodyScrolled !== "undefined" ? hasBodyScrolled : undefined, "sortField" in locals ? locals.sortField : typeof sortField !== "undefined" ? sortField : undefined, "sortOrder" in locals ? locals.sortOrder : typeof sortOrder !== "undefined" ? sortOrder : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;